export const selectGeoLocationRows = (state) => state.geoLocations.rows;

export const selectGeoLocationsHasMore = (state) => state.geoLocations.hasMore;

export const selectGeoLocationsLoading = (state) => state.geoLocations.loading;

export const selectGeoLocationsError = (state) => state.geoLocations.error;

export const selectGeoLocationFilters = (state) => state.geoLocations.filters;

export const selectGeoLocationUsers = (state) => state.geoLocations.users;

export const selectGeoLocationsPurging = (state) => state.geoLocations.purging;
